import { useDispatch } from 'react-redux';
// @ts-expect-error Untyped module
import { closePatagoniaSidebar } from 'ContentEditorUI/redux/actions/panelActions';
import UICloseButton from 'UIComponents/button/UICloseButton';
import { H5 } from 'UIComponents/elements/headings';
import UsageTracker from 'ContentEditorUI/utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PatagoniaSidebarHeader = ({
  headerText
}) => {
  const dispatch = useDispatch();
  function handleCloseSidebar() {
    UsageTracker.trackEditorInteraction({
      action: 'Toggle Sidebar',
      event: 'Close sidebar'
    });
    dispatch(closePatagoniaSidebar());
  }
  return /*#__PURE__*/_jsxs("div", {
    className: "patagonia-sidebar-header",
    children: [/*#__PURE__*/_jsx("div", {
      className: "patagonia-sidebar-header-text",
      children: /*#__PURE__*/_jsx(H5, {
        children: headerText
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "patagonia-sidebar-header-close",
      children: /*#__PURE__*/_jsx(UICloseButton, {
        className: "patagonia-sidebar-header-close-button",
        size: "medium",
        onClick: handleCloseSidebar,
        "data-selenium": "save-and-close-sidebar"
      })
    })]
  });
};
export default PatagoniaSidebarHeader;